import React from 'react';
import { Avatar } from 'components/misc';
import VIPBadge from 'components/ChatHeader/VIPBadge';
import VipLockIcon from 'assets/vipIcons/vip_loc_icon.svg';
import VipCloseIcon from 'assets/vipIcons/vip_icon_close.svg';
import { inject, observer } from 'mobx-react';

const VipChatLocked = ({ profile, options, store }) => {
  const { siteStyles, translations, features } = options;
  const { purchaseSuccess, isLoading } = store.conversation.featuredApUnlock;

  const unlockChatWithCredits = () => {
    if (isLoading) { return; }
    store.conversation.unlockFeaturedAp();
  }

  const becomeVipMember = () => {
    options.hooks?.onPurchaseFeaturedMembership?.(data => {
      if (data === 'purchaseFeaturedMembershipCredit') {
        store.conversation.featuredApUnlock.unlockChatWithCredits();
      }
    })
  }
  const closeChat = () => {
    store.conversation.featuredApUnlock.toggleChatLocked(false);
  }

  const creditsPerFeaturedAPUnlock = features.isCreditSite ? translations.creditsPerFeaturedAPUnlock : null
  return (
    <div className="vip-chat-locked">
        {purchaseSuccess && <div className="vip-chat-locked__close" style={{ '--text-secondary': siteStyles.textSecondary }} onClick={closeChat}>
            <VipCloseIcon/>
        </div>}
        <div className="vip-chat-locked__avatar">
            <div className="vip-chat-locked__badge">
                <VIPBadge siteStyles={siteStyles}/>
            </div>
            <Avatar user={profile} isActive/>
        </div>
        {!purchaseSuccess && <>
        <div className="vip-chat-locked__title">Unlock VIP Chat</div>
        <div className="vip-chat-locked__description">
        You're just one step away from chatting with this exclusive profile.
        </div>
        <div className="vip-chat-locked__options">
            <div className="vip-chat-locked__option">Become a VIP Member</div>
            <div
              className="vip-chat-locked__option vip-chat-locked__option--credits"
              dangerouslySetInnerHTML={{ __html: creditsPerFeaturedAPUnlock }}
            />
        </div>
        <div className="vip-chat-locked__buttons">
            <button disabled={isLoading} className="vip-chat-locked__button vip-chat-locked__button--unlock" onClick={unlockChatWithCredits}>
                <span className="vip-chat-locked__button-icon" style={{ '--vip-cta-color': siteStyles.cta }}>
                    <VipLockIcon/>
                </span>
                UNLOCK CHAT
            </button>
            <button disabled={isLoading} className="vip-chat-locked__button vip-chat-locked__button--vip" onClick={becomeVipMember}>
                    BECOME VIP MEMBER
                </button>
            </div>
        </>}
        {purchaseSuccess && <>
        <div className="vip-chat-locked__description">
          You've unlocked this VIP chat.
          Continue chatting...
        </div>
        </>}
    </div>
  )
};

export default inject('store', 'actions')(observer(VipChatLocked));
